import { Theme } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

interface AccordionStylesProps {
  expanded: boolean
}
const useStyles = makeStyles<Theme, AccordionStylesProps>(theme => ({
  accordion: {
    padding: '0.60rem 0.5rem',
    backgroundColor: '#F5F6F8'
  },

  accordionContainer: {
    backgroundColor: 'white',
    padding: '0.5rem 0.5rem',
    borderRadius: '5px'
  },

  accordionTitle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    cursor: 'pointer',
    padding: '0.5rem 0.5rem'
  },

  titleText: {
    width: '100%',
    fontStyle: 'normal',
    fontSize: theme.size.base
  },

  accordionContent: {
    overflow: 'hidden',
    maxHeight: '1000000px',
    transition: `max-height 3s ease-in-out`,

    '&[aria-expanded="true"]': {
      maxHeight: '0px',
      transition: `max-height 0.5s cubic-bezier(0, 1, 0, 1)`
    }
  },
  accordionPadding: {
    padding: '0.5rem 0.5rem'
  },
  icon: {
    transform: ({ expanded }) => (expanded ? `rotate(180deg)` : `rotate(0deg)`),
    transition: `transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms`
  }
}))

export default useStyles
